import React, { Component } from 'react';
import Caption from './caption';
import { trackInfographicHover } from '../../tracking';
import LazyImage from '../ui/lazyImage';
import * as style from './hotspots.module.scss';

let Flickity;

const Marker = props => (
  <div
    className={props.active ? style.markerActive : style.marker}
    onMouseEnter={e => {
      props.handleMouseEnter(e, props.index);
    }}
    onMouseLeave={props.handleMouseLeave}
    onTouchStart={e => {
      props.handleMouseEnter(e, props.index);
    }}
    style={{
      left: props.x,
      top: props.y,
      animationDelay: `${props.index * 500}ms`,
    }}
  />
);

// Positions box arrow pointer on top, righ, bottom, left, etc.
const getBlockStyles = (x, y) => {
  const blockStyle = {
    style: {},
  };
  const xNum = parseFloat(x.slice(0, -1));
  const yNum = parseFloat(y.slice(0, -1));
  if (xNum > 50) {
    blockStyle.classX = style.blockRight;
    blockStyle.style.right = `${100 - xNum}%`;
  } else {
    blockStyle.classX = style.blockLeft;
    blockStyle.style.left = x;
  }
  if (yNum > 50) {
    blockStyle.classY = style.blockBottom;
    blockStyle.style.bottom = `${100 - yNum}%`;
  } else {
    blockStyle.classY = style.blockTop;
    blockStyle.style.top = y;
  }
  return blockStyle;
};

const TextBlock = props => {
  const blockStyle = !props.mobile && getBlockStyles(props.x, props.y);
  return (
    <div
      className={`${
        props.active ? style.textBlockActive : style.textBlock
      } ${!props.mobile && blockStyle.classX} ${!props.mobile &&
        blockStyle.classY} ${
        props.mobile ? style.mobileBlock : style.desktopBlock
      } typeFonts2 ${props.mobile ? 'typeColorDark1' : 'typeColorLight1'} ${
        props.mobile ? 'hotspotCell' : ''
      } `}
      style={props.mobile ? {} : blockStyle.style}
    >
      <div className={style.blockInner}>
        <header>
          {props.title && <h3>{props.title}</h3>}
          {props.subtitle && (
            <p className={`${style.blockSubtitle}`}>{props.subtitle}</p>
          )}
        </header>
        {props.text && (
          <div
            className={style.textBlock}
            dangerouslySetInnerHTML={{ __html: props.text }}
          />
        )}
      </div>
    </div>
  );
};

class Hotspots extends Component {
  constructor() {
    super();
    this.state = {
      current: null,
    };
  }
  componentDidMount() {
    const flickOpts = {
      cellSelector: '.hotspotCell',
      cellAlign: 'left',
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
    };

    // enable prev/next buttons at 768px
    if (matchMedia('screen and (min-width: 768px)').matches) {
      flickOpts.cellAlign = 'center';
    }
    if (typeof window !== 'undefined') {
      Flickity = require('flickity');
      this.flkty = new Flickity(this.mobileCarouselElement, flickOpts);
      this.flkty.on('select', this.updateMobileCurrent);
      if (window.innerWidth < 980) {
        this.setState({ current: 0 });
      }
    }
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  handleResize = () => {
    if (window.innerWidth >= 980) {
      this.setState({ current: null });
    }
  };
  updateMobileCurrent = () => {
    if (window.innerWidth < 980) {
      this.setState({
        current: this.flkty.selectedIndex,
      });
    }
  };
  markerEnter = (e, index) => {
    e.stopPropagation();
    if (window.innerWidth >= 980) {
      trackInfographicHover();
      this.setState({ current: index });
    }
  };
  markerLeave = e => {
    e.stopPropagation();
    if (window.innerWidth >= 980) {
      this.setState({ current: null });
    }
  };
  render() {
    return (
      <div>
        <div
          className={`${style.hotspots} ${
            this.props.size === 'hotspot-large' ? style.largeSpots : ''
          }`}
        >
          <div className={`${style.imgWrap} typeFonts1`}>
            {this.props.heading && (
              <h2
                className={`${style.header} fadeInBlur reveal reveal-delay-500`}
              >
                {this.props.heading}
              </h2>
            )}
            <div
              className={`${style.bkImage} fadeInUp reveal`}
              onTouchStart={this.markerLeave}
            >
              <LazyImage
                src={this.props.src}
                alt={this.props.altText}
                hasRevealer={this.props.hasRevealer}
                revealed={this.props.revealed}
                width={this.props.imgDimensions.width}
                height={this.props.imgDimensions.height}
                opacity={1}
                fitSize
              />
              <div>
                {this.props.hotspots.map((spot, i) => (
                  <Marker
                    active={this.state.current === i}
                    handleMouseEnter={this.markerEnter}
                    handleMouseLeave={this.markerLeave}
                    x={spot.x_coordinate}
                    y={spot.y_coordinate}
                    index={i}
                    key={`marker${i}`}
                  />
                ))}
              </div>
            </div>
            <div className={style.textBlockWrapper}>
              {this.props.hotspots.map((spot, i) => (
                <TextBlock
                  active={this.state.current === i}
                  x={spot.x_coordinate}
                  y={spot.y_coordinate}
                  index={i}
                  key={`text${i}`}
                  title={spot.title}
                  subtitle={spot.subtitle}
                  text={spot.text}
                  mobile={false}
                />
              ))}
            </div>
          </div>
          <div className="fadeIn reveal">
            <div
              ref={el => {
                this.mobileCarouselElement = el;
              }}
              className={style.mobileTextBlockWrapper}
            >
              {this.props.hotspots.map((spot, i) => (
                <TextBlock
                  index={i}
                  key={`mobiletext${i}`}
                  title={spot.title}
                  subtitle={spot.subtitle}
                  text={spot.text}
                  mobile={true}
                />
              ))}
            </div>
            {this.props.caption && (
              <div className="text-block">
                <div className={style.caption}>
                  <Caption captionText={this.props.caption} />
                </div>
              </div>
            )}
            <div className={`text-block ${style.mobileBorder}`} />
          </div>
        </div>
      </div>
    );
  }
}

export default Hotspots;
